export const steelWork = {
  type: 'Steel Work',
  arType: 'اعمال حديد',
  assets: [
    {
      id: 1,
      img: 'https://storage.googleapis.com/door-assets/site/steel_work/11_1.jpg',
      title: '',
    },
    {
      id: 2,
      img: 'https://storage.googleapis.com/door-assets/site/steel_work/11_2.jpg',
      title: '',
    },
    {
      id: 3,
      img: 'https://storage.googleapis.com/door-assets/site/steel_work/11_4.jpg',
      title: '',
    },
    {
      id: 4,
      img: 'https://storage.googleapis.com/door-assets/site/steel_work/IMG_0655_web.jpg',
      title: '',
    },
    {
      id: 5,
      img: 'https://storage.googleapis.com/door-assets/site/steel_work/IMG_1497.JPG',
      title: '',
    },
    {
      id: 6,
      img: 'https://storage.googleapis.com/door-assets/site/steel_work/IMG_5595.jpg',
      title: '',
    },
    {
      id: 7,
      img: 'https://storage.googleapis.com/door-assets/site/steel_work/IMG_E2009.JPG',
      title: '',
    },
    {
      id: 6,
      img: 'https://storage.googleapis.com/door-assets/site/steel_work/JJLCE8177.JPG',
      title: '',
    },
    {
      id: 7,
      img: 'https://storage.googleapis.com/door-assets/site/steel_work/d7.jpg',
      title: '',
    },
    {
      id: 8,
      img: 'https://storage.googleapis.com/door-assets/site/steel_work/IMG_1529.jpg',
      title: '',
    },
    {
      id: 9,
      img: 'https://storage.googleapis.com/door-assets/site/steel_work/IMG_1525.jpg',
      title: '',
    },
    {
      id: 10,
      img: 'https://storage.googleapis.com/door-assets/site/steel_work/IMG_0991.jpg',
      title: '',
    },
  ]
};
